<div class="col-xl-12" *ngIf="passwordForm">
	<h1 mat-dialog-title>{{data.title}}</h1>
	<div mat-dialog-content>
		<mat-card>
			<mat-card-content>
				<div class="form-group" [formGroup]="passwordForm">
					<mat-form-field appearance="fill" style="margin-bottom: 5px;" *ngIf="!toVerify">
						<mat-label>{{'Old Password' | translate}}</mat-label>
						<input matInput [type]="showOldPassword ? 'text' : 'password'" name="oldpassword"
							formControlName="oldpassword" autocomplete="off">
						<button mat-icon-button matSuffix type="button"
							*ngIf="showOldPassword && passwordForm.controls.oldpassword.value.length"
							class="password-eye" (click)="showOldPassword = !showOldPassword">
							<mat-icon>visibility</mat-icon>
						</button>
						<button mat-icon-button matSuffix type="button"
							*ngIf="!showOldPassword && passwordForm.controls.oldpassword.value.length"
							class="password-eye" (click)="showOldPassword = !showOldPassword">
							<mat-icon>visibility_off</mat-icon>
						</button>
						<mat-error *ngIf="passwordForm.controls.oldpassword.errors?.incorrect">
							The password you entered is incorrect.
						</mat-error>
					</mat-form-field>
					<mat-form-field appearance="fill" style="margin-bottom: 5px;" *ngIf="toVerify">
						<mat-label>{{'Verification Code' | translate}}</mat-label>
						<input matInput type="text" name="oldpassword" formControlName="oldpassword">
						<mat-error *ngIf="passwordForm.controls.oldpassword.errors?.incorrect">
							The password you entered is incorrect.
						</mat-error>
					</mat-form-field>
					<mat-form-field appearance="fill" style="margin-bottom: 45px;">
						<mat-label>{{'New Password' | translate}}</mat-label>
						<input matInput [type]="showNewPassword ? 'text' : 'password'" name="password"
							formControlName="password" autocomplete="off">
						<button mat-icon-button matSuffix type="button"
							*ngIf="showNewPassword && passwordForm.controls.password.value.length"
							class="password-eye" (click)="showNewPassword = !showNewPassword">
							<mat-icon>visibility</mat-icon>
						</button>
						<button mat-icon-button matSuffix type="button"
							*ngIf="!showNewPassword && passwordForm.controls.password.value.length"
							class="password-eye" (click)="showNewPassword = !showNewPassword">
							<mat-icon>visibility_off</mat-icon>
						</button>
						<mat-error *ngIf="passwordForm.controls.password.errors?.pattern">
							The password you entered does not meet the minimum security requirements.
						</mat-error>
						<mat-error
							*ngIf="passwordForm.controls.password.errors?.hasOwnProperty('same') && passwordForm.controls.password.errors.same !== null">
							The password you entered is the same as the old password. Please enter a new password.
						</mat-error>
						<mat-hint>Your password must contain at least 8 characters including lower and upper case
							letters,
							numbers, and special characters.</mat-hint>
					</mat-form-field>
					<mat-form-field appearance="fill">
						<mat-label>{{'Confirm Password' | translate}}</mat-label>
						<input matInput [type]="showConfirmPassword ? 'text' : 'password'" name="confirmpassword"
							formControlName="confirmpassword" autocomplete="off">
						<button mat-icon-button matSuffix type="button"
							*ngIf="showConfirmPassword && passwordForm.controls.confirmpassword.value.length"
							class="password-eye" (click)="showConfirmPassword = !showConfirmPassword">
							<mat-icon>visibility</mat-icon>
						</button>
						<button mat-icon-button matSuffix type="button"
							*ngIf="!showConfirmPassword && passwordForm.controls.confirmpassword.value.length"
							class="password-eye" (click)="showConfirmPassword = !showConfirmPassword">
							<mat-icon>visibility_off</mat-icon>
						</button>
						<mat-error>
							The passwords you entered do not match.
						</mat-error>
					</mat-form-field>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div mat-dialog-actions>
		<button color="danger" mat-raised-button (click)="closeModal(undefined)">{{'Close' | translate}}</button>
		<button mat-raised-button [disabled]="(loading$ | async) || passwordForm.controls.password.errors?.pattern"
			(click)="saveData()" cdkFocusInitial>{{'Save' |
			translate}}</button>
	</div>
	<br />
</div>